<template>
  <div class="card" :class="[{ [`card-${type}`]: type }]">
    <div v-if="$slots.default" class="card-body">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "card",
  props: {
    type: String,
    title: String,
    icon: String,
    header: Boolean
  }
};
</script>
<style lang="scss" scoped>
.big-padding {
  padding: $big-padding;
}
p {
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0px;
  }
}
</style>
